import moment from 'moment'

export function formateDatetime(date, format?) {
    if (format === undefined) {
        format = 'MMM DD YYYY HH:mm:ss'
    }
    return moment(date).format(format)
}
